const renderRemarksValue = (value) => {
  if (typeof value !== "string") {
    return value;
  }

  return value.split("\n").map((line, index) => {
    const sourceMatch = line.match(/^Source:\s+(https?:\/\/\S+)$/);
    if (sourceMatch) {
      return (
        <div key={`remarks-line-${index}`}>
          Source:{" "}
          <a href={sourceMatch[1]} target="_blank" rel="noreferrer">
            {sourceMatch[1]}
          </a>
        </div>
      );
    }

    return <div key={`remarks-line-${index}`}>{line}</div>;
  });
};

const HIGHLIGHTED_LABELS = new Set(["Coordinates (decimal)"]);
const SPECIES_MISMATCH_LABELS = new Set(["Ringing Species", "Scientific Name"]);
const SEX_MISMATCH_LABEL = "Sex";

const isMismatchRow = (label, { speciesMismatch, sexMismatch }) =>
  (speciesMismatch && SPECIES_MISMATCH_LABELS.has(label)) ||
  (sexMismatch && label === SEX_MISMATCH_LABEL);

const renderRows = (rows, mismatchFlags = {}) =>
  rows.map(([label, value]) => {
    const classes = [];
    if (isMismatchRow(label, mismatchFlags)) {
      classes.push("resighting-qc-record-row-mismatch");
    }
    if (HIGHLIGHTED_LABELS.has(label)) {
      classes.push("resighting-qc-record-row-highlight");
    }

    return (
      <tr key={label} className={classes.join(" ") || undefined}>
        <th>{label}</th>
        <td>
          {label === "Remarks" ? (
            renderRemarksValue(value)
          ) : typeof value === "string" && /^https?:\/\//.test(value) ? (
            <a href={value} target="_blank" rel="noreferrer">
              {value}
            </a>
          ) : (
            value
          )}
        </td>
      </tr>
    );
  });

function ResightingRecordDetails({ record }) {
  const mismatchFlags = {
    speciesMismatch: record?.speciesMismatch ?? false,
    sexMismatch: record?.sexMismatch ?? false,
  };

  return (
    <div className="resighting-qc-details-grid" style={{marginTop: '1rem'}}>
      <div className="resighting-qc-details-grid-item">
        <h3 className="resighting-qc-subsection-title">Ringing details</h3>
        <table className="resighting-qc-record-table">
          <tbody>{renderRows(record?.ringingRows || [], mismatchFlags)}</tbody>
        </table>
      </div>
      <div className="resighting-qc-details-grid-item">
        {record?.mapCoordinates ? (
          <div className="resighting-qc-map-wrap">
            <iframe
              title={`Record ${record?.recordId} location map`}
              className="resighting-qc-map-frame"
              src={`https://maps.google.com/maps?q=${record.mapCoordinates.lat},${record.mapCoordinates.lon}&z=6&output=embed`}
              loading="lazy"
            />
          </div>
        ) : null}
      </div>
      <div className="resighting-qc-details-grid-item">
        <h3 className="resighting-qc-subsection-title">Resighting details</h3>
        <table className="resighting-qc-record-table">
          <tbody>{renderRows(record?.resightingRows || [], mismatchFlags)}</tbody>
        </table>
      </div>
    </div>
  );
}

export default ResightingRecordDetails;
